import { render, staticRenderFns } from "./Industries.vue?vue&type=template&id=8574aea0"
import script from "./Industries.vue?vue&type=script&lang=js"
export * from "./Industries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports